export default "__VITE_ASSET__BNTaSyQ7__"